export const playerButtons = {
  PLAY_BUTTON: 'play-button',
  AUDIO_AND_SUBTITLES_BUTTON: 'audioAndSubtitles-button',
}

export const PlayerName = {
  BITMOVIN: 'Bitmovin',
  HLS: 'HLS',
  MUX: 'Mux',
}

export const progressBarInfinityValue = 99999
export const btnRecommendationTimeout = 1000
export const disabledAudioValue = '-1'
export const disabledSubtitleValue = 'subtitle-off'
export const playerId = 'player'
